// Date & time field capability – i18n manifest (veřejný kontrakt pro composition).
// Nese jen UI akční labely a chybové hlášky; kalendářní data (názvy měsíců/dnů, formát,
// první den týdne) žijí inline v `internal/dateLocale.ts` (viz komentář tamtéž).

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'dateTimeField';

export const dateTimeFieldI18nManifest: SliceI18nManifest = {
  owner: 'shared/ui/date-time-field',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
